export const courses = {
  title: "Cursos",
  subtitle: "Formação especializada para educadores, mães e pais",
  accompaniment: {
    title: "Curso de acompanhamento:",
    subtitle: "Acompanhar meninas e meninos (2025-2026)",
    description: "Ferramentas pessoais para o/a acompanhante. O prazer de aprender por descoberta.\n\nCurso de formação dirigido a educadores/as, mães e pais no qual utilizaremos uma metodologia participativa, com momentos para refletir e partilhar, dedicando muito tempo a vivenciar e praticar as habilidades relacionadas com cada tema.",
    trainers: {
      title: "Formadores",
      names: "Tinus Wijnakker e Beatriz Aguilera Reija, fundadores da escola Alavida em Madrid com 25 anos de experiência."
    },
    duration: {
      title: "Duração",
      block1: "1º bloco: 24 horas",
      block2: "2º bloco: 24 horas", 
      block3: "3º bloco: 36 horas"
    },
    dates: {
      title: "Datas",
      block1: "1º bloco",
      block1Dates: "7-8 de novembro / 28-29 de novembro",
      block2: "2º bloco", 
      block2Dates: "23-24 de janeiro / 20-21 de fevereiro",
      block3: "3º bloco",
      block3Dates: "27-28 de março/ 24-25 de abril /22-23 de maio"
    },
    schedule: {
      title: "Horário",
      friday: "Sexta-feira",
      fridayTime: "das 17:30 às 21:30h",
      saturday: "Sábados", 
      saturdayTime: "das 9:00 às 13:30h e das 15:00 às 18:30h"
    },
    location: {
      title: "Local",
      place: "Gándara International School"
    },
    capacity: {
      title: "Capacidade máxima",
      block1: "Primeiro bloco: capacidade máxima: 25 pessoas",
      blocks23: "Segundo e Terceiro bloco: capacidade máxima: 30 pessoas. (Podem inscrever-se também participantes de cursos anteriores)."
    },
    prices: {
      title: "Preços",
      fullEarly: "Curso completo (pagando antes de 10 de outubro): 500€",
      fullBlocks: "Curso completo (pagando em três blocos): 160€ + 160€ + 240€ = 560€",
      block12: "Bloco 1 ou 2 separadamente: 170€",
      block3: "Bloco 3: 240€",
      note1: "Para participar apenas no bloco 3 será necessário ter feito previamente alguma formação com Tinus Wijnakker.",
      note2: "As pessoas que se inscrevem no curso completo têm preferência."
    },
    content: {
      title: "CONTEÚDOS DO CURSO:",
      blocks12: {
        title: "1º e 2º bloco: Ferramentas pessoais para o/a acompanhante",
        instructor: "A cargo de Tinus Wijnakker",
        block1: {
          title: "Bloco 1 - 1º fim de semana (7-8 de novembro)",
          topic: "A observação e processos de comunicação:",
          point1: "Como observamos? e Como nos afeta a nossa maneira de observar?",
          point2: "A importância de ver e entender os sinais de comunicação.",
          point3: "A comunicação não-verbal e a verbal",
          point4: "Como interpretar as mensagens de meninas e meninos?"
        },
        weekend2: {
          title: "2º fim de semana (28-29 de novembro)",
          topic: "A escuta ativa:",
          point1: "Escutar para entender e acompanhar.",
          point2: "A linguagem da aceitação: Refletir e acompanhar.",
          point3: "A comunicação não-verbal e o contacto físico"
        }
      },
      block2: {
        title: "Bloco 2",
        weekend3: {
          title: "3º fim de semana (23-24 de janeiro)",
          topic1: "Amor e segurança:",
          point1: "Necessidades básicas.",
          point2: "Como alguém se sente amado/a e seguro/a?",
          point3: "Apoio emocional.",
          point4: "Escutar, aceitar e acompanhar sentimentos.",
          topic2: "Liberdade, limites e autonomia:",
          point5: "Um ambiente relaxado.",
          point6: "Limites, normas de convivência e castigos.",
          point7: "Liberdade e autonomia."
        },
        weekend4: {
          title: "4º fim de semana (20-21 de fevereiro)",
          topic: "Situações conflituosas:",
          point1: "Conflitos, agressividade e violência.",
          point2: "Analisar uma situação conflituosa.",
          point3: "Acompanhar para facilitar o processo de regulação."
        }
      },
      block3: {
        title: "Bloco 3: O prazer de aprender por descoberta.",
        instructors: "A cargo de Beatriz Aguilera e Tinus Wijnakker",
        weekend5: {
          title: "5º fim de semana (27-28 de março)",
          topic1: "Etapas evolutivas:",
          point1: "Infância: dos 0 aos 6 anos: etapa sensório-motriz-afetiva",
          point2: "Meninice: dos 6 aos 12 anos: etapa das operações concretas",
          topic2: "Ambientes preparados:",
          point3: "Os cantos.",
          point4: "As estruturas."
        },
        weekend6: {
          title: "6º fim de semana (24-25 de abril)",
          topic1: "O papel do adulto:",
          point1: "O vínculo e o apoio emocional",
          point2: "Guia e referência.",
          topic2: "A convivência:",
          point3: "O processo de relações pessoais e grupais.",
          point4: "Responsabilidades e autonomia.",
          point5: "Limites, normas de convivência e consequências.",
          point6: "As situações de conflitos."
        },
        weekend7: {
          title: "7º fim de semana (22-23 de maio)",
          topic: "O processo de aprendizagem:",
          point1: "Como aprendem as meninas e os meninos?",
          point2: "Fatores sociais e emocionais.",
          point3: "A curiosidade e o interesse como motores de aprendizagem",
          point4: "Aprendizagem autónoma",
          point5: "Apresentações",
          point6: "A aprendizagem por descoberta"
        }
      }
    }
  },
  psychomotricity: {
    title: "CURSO PSICOMOTRICIDADE EDUCATIVA",
    subtitle: "\"Psicomotricidade na educação infantil e primeiro ciclo do primário. Teoria e recursos para a aula\"",
    dateTime: {
      title: "Data e Horário",
      details: "25 de outubro das 10:00 às 17:00 na Gándara School em Gondomar."
    },
    price: {
      title: "Preço",
      amount: "60€/pessoa"
    },
    lunchNote: "Haverá uma pausa para comer, recomendamos trazer marmita com comida e desfrutar do espaço e da companhia neste momento de descanso.",
    content: {
      title: "Conteúdo do curso:",
      point1: "Trabalho de sensibilização corporal",
      point2: "Iniciação à teoria da psicomotricidade relacional",
      point3: "Jogos e dinâmicas corporais para trabalhar nos ciclos educativos 3-8 anos",
      point4: "Revisaremos os aspetos fundamentais da prática psicomotriz",
      point5: "Adaptaremos as dinâmicas segundo as necessidades educativas das pessoas que participem na formação para que tenham recursos para fazer nas aulas",
      point6: "Levarão textos de teoria e prática para ampliar os conhecimentos após a formação."
    }
  },
  contact: {
    title: "Mais informações e inscrições",
    description: "Para mais informações e/ou inscrições:"
  }
};